import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import { chatApi } from './chatApi';

// Define the type for state
interface AccountState {
  conversations: any;
  messageList: any;
}

const initialState: AccountState = { conversations: [], messageList: [] };

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setConversations: (state, action: PayloadAction<any>) => {
      state.conversations = action.payload;
    },
    setMessageList: (state, action: PayloadAction<any>) => {
      state.conversations = action.payload;
    },
    setChatStateInitial: (state) => {
      state.conversations = [];
      state.messageList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(chatApi.endpoints.filterConversation.matchFulfilled, (state, action) => {
        state.conversations = action?.payload?.list ?? null;
      })
      .addMatcher(chatApi.endpoints.createConversation.matchFulfilled, (state, action) => {
        state.conversations = state.conversations
          ? [...state.conversations, action.payload?.list]
          : [action.payload?.list];
      })
      .addMatcher(chatApi.endpoints.getMessageList.matchFulfilled, (state, action) => {
        state.messageList = state.messageList
          ? [...action.payload.list, ...state.messageList] // Prepend messages
          : [...action.payload.list]; // Ensure list initializes correctly

        // state.totalPages = action.payload.totalPages; // Store total pages for future requests
      })

      .addMatcher(chatApi.endpoints.sendMessage.matchFulfilled, (state, action) => {
        state.messageList = state.messageList
          ? [...state.messageList, action.payload]
          : [action.payload];
      });

    // .addMatcher(accountAPi.endpoints.deleteAccount.matchFulfilled, (state, action) => {
    //   state.accountList =
    //     state.accountList?.filter((account) => account.id !== action.payload.id) || [];
    // });
  },
});

export const { setConversations, setMessageList, setChatStateInitial } = chatSlice.actions;
export default chatSlice.reducer;
